import {
  Text,
  Flex,
  Heading,
  Stack,
  Box,
  Tabs,
  IconButton,
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../components/shared/CommonContainer";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

export default function TermsPage() {
  const [tab, setTab] = React.useState("Key Terms");
  const tabBtnListRef = React.useRef();
  const prevSelected = () => {
    let newSelection = list.indexOf(tab);

    return list[newSelection === 0 ? list.length - 1 : newSelection - 1];
  };
  const prevClickHandler = () => {
    let indexOfPrev = list.indexOf(tab);
    let newIndexOfPrev = indexOfPrev === 0 ? list.length - 1 : indexOfPrev - 1;
    setTab(list[newIndexOfPrev]);
    tabBtnListRef.current?.children[newIndexOfPrev].click();
  };
  const nextSelected = () => {
    let newSelection = list.indexOf(tab);

    return list[newSelection === list.length - 1 ? 0 : newSelection + 1];
  };
  const nextClickHandler = () => {
    let indexOfPrev = list.indexOf(tab);
    let newIndexOfPrev = indexOfPrev === list.length - 1 ? 0 : indexOfPrev + 1;
    setTab(list[newIndexOfPrev]);
    
    tabBtnListRef.current?.children[newIndexOfPrev].click();
  };
  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="center"
        height={{ base: "200px", md: "300px" }}
        bgGradient="linear(to-b,#0079BC,#74C7F5)"
        color="white"
      >
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "22px", md: 36 }}
          pb={{ base: 10, md: 20 }}
        >
          Decolance Terms of Service
        </Heading>
      </Flex>
      <CommonContainer>
        <Stack
          bg="brand.50"
          p={{base:5,lg:10}}
          pos="relative"
          bottom={20}
          borderRadius={10}
          fontSize={{ md: "19px" }}
        >
          <Text pb={4} color="black">
            Last Update: September 2022
          </Text>
          <Text color="#8f8f8f" pb={10}>
            Welcome to Decolance.io
            <br />
            <br />
            The following terms of service ("Terms of Service") govern your use
            of www.decolance.io and the Decolance mobile application (the
            "Site"), as well as any content, features, and services made
            available on or via those platforms by Decolance and its
            subsidiaries collectively. You are referred to as "You" or "user" on
            the Site.
            <br />
            <br />
            Please review the Terms of Service carefully before using the
            website. By using the Site, creating an account, or clicking to
            accept or agree to the Terms of Service when this option is made
            available to you, you accept and agree to be bound by these Terms of
            Service and the Decolance Payment Terms, which can be found here
            ("Payment Terms'') and are incorporated herein by reference. You
            also acknowledge having read and comprehend our privacy statement,
            which may be found here. You are not permitted to access or use the
            Site if you do not agree to these Terms of Service or the Privacy
            Statement. Please refer to the relevant articles in this section for
            more information on the usage and activity policies regulating the
            Site.
            <br />
            <br />
            This website is provided and accessible to those who are at least 18
            years old and of legal contracting age. If you are under the age of
            18 and at least 13 years old, you may only use this site through a
            parent or legal guardian's account with their consent. If you are
            under 13 years old, you are not permitted to use this website or its
            services. You represent and warrant that you meet all of the
            aforementioned conditions by using this site. If you do not satisfy
            all of these conditions, you are not permitted to access or use the
            Site. Our Customer Support team is available 24 hours a day, seven
            days a week if you have any issues about the Site or Terms of
            Service. You can contact our Customer Support staff by making a
            request here.
            <br />
            <br />
            The original language of these Terms of Service and all other site
            texts is English. Decolance provides this translation for your
            convenience. In the event of a discrepancy between the English
            version and any translation, the English version shall take
            precedence.
          </Text>
          <Flex
            justifyContent="space-between"
            alignItems="start"
            flexDir={{ base: "column", lg: "row" }}
            mb={10}
            py={{ base: 10, md: 20 }}
          >
            <Box
              fontSize={{ base: "12px", md: "14px" }}
              w="25%"
              pr={2}
              display={{ base: "none", lg: "block" }}
            >
              {list.map((item) => {
                return (
                  <Text
                    textDecoration={"underline"}
                    color={item === tab ? "brand.500" : "#8F8F8F"}
                    cursor="pointer"
                    pb={4}
                    key={item}
                    onClick={() => {
                      setTab(item);
                    }}
                  >
                    {item}
                  </Text>
                );
              })}
            </Box>
            <Tabs
              variant="unstyled"
              sx={{ border: "1px solid #c5c5c5" }}
              borderRadius={10}
              overflow="hidden"
              spacing={0}
              w="100%"
              display={{lg:"none"}}
              mb={5}
            >
              <Flex
                pos="relative"
                display={{ base: "flex", lg: "none" }}
                justifyContent={"center"}
                overflow="hidden"
              >
                <Box
                  fontSize="12px"
                  _selected={{ color: "white", bg: "brand.500" }}
                  bg="#f1f1f1"
                  w="full"
                  border="1px solid #c5c5c5"
                  borderLeft={0}
                  borderTop={0}
                  fontWeight={500}
                  sx={{ py: 4 }}
                  minW="120px"
                  rounded="none"
                  px={1}
                  textAlign={"center"}

                >
                  {prevSelected()}
                </Box>
                <Box
                  fontSize="12px"
                  rounded="none"
                  bg="brand.500"
                  color="white"
                  w="full"
                  border="1px solid #c5c5c5"
                  borderLeft={0}
                  borderTop={0}
                  fontWeight={500}
                  sx={{ py: 4 }}
                  px={1}
                  minW="120px"
                  textAlign="center"
                >
                  {tab}
                </Box>
                <Box
                  fontSize="12px"
                  bg="#f1f1f1"
                  w="full"
                  border="1px solid #c5c5c5"
                  borderLeft={0}
                  borderTop={0}
                  fontWeight={500}
                  sx={{ py: 4 }}
                  minW="120px"
                  px={1}
                  textAlign={"center"}
                  rounded="none"
                  
                  overflow="hidden"
                  wordBreak={"break-word"}
                >
                  {nextSelected()}
                </Box>
                <IconButton
                  pos="absolute"
                  left="0"
                  height="full"
                  background={"none"}
                  _hover={{
                    bgGradient:
                      "linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))",
                  }}
                  borderBottom="1px"
                  rounded="none"
                  borderColor="#c5c5c5"
                  justifyContent="start"
                  bgGradient="linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"
                  w="50px"
                  pr={1}
                  onClick={prevClickHandler}
                >
                  <AiOutlineLeft />
                </IconButton>
                <IconButton
                  pos="absolute"
                  right={0}
                  justifyContent="end"
                  m={0}
                  height="full"
                  background={"none"}
                  _hover={{
                    bgGradient:
                      "linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)",
                  }}
                  borderBottom="1px"
                  rounded="none"
                  borderColor="#c5c5c5"
                  bgGradient="linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"
                  w="50px"
                  pr={1}
                  onClick={nextClickHandler}
                >
                  <AiOutlineRight />
                </IconButton>
              </Flex>
            </Tabs>
            <Box
              px={{ base: 5, lg: 10 }}
              fontSize={{ md: "19px" }}
              w={{ lg: "75%" }}
              borderLeft={{ lg: "1px" }}
              borderColor="gray.500"
              color="gray.500"
            >
              <Heading
                fontWeight={400}
                pb={5}
                fontSize={{ base: "21px", md: "27px" }}
                color="black"
              >
                {tab}
              </Heading>
              <Text pb={2}>
                Buyers are users who purchase services via Decolance.
                <br />
                Custom Offers are one-of-a-kind proposals that a seller might
                construct in response to a buyer's special needs.
                <br />
                Custom Orders are requests made by a Buyer for a Seller to
                provide a Custom Offer.
                <br />
                Job Extras are supplementary services supplied in addition to
                the Seller's Job for a price determined by the Seller.
                <br />
                Job Packages enable Sellers to offer their services in a variety
                of forms and price points. Packages can include upgrades,
                allowing sellers to set a base price for their service.
                <br />
                Job Page is where the Seller can describe their Job and its
                terms, and where the Buyer can purchase the Job by placing an
                order.
                <br />
                Job / Jobs are services offered on Decolance.
                <br />
                Order Page is where Buyers and Sellers communicate with each
                other in connection with an ordered Job.
                <br />
                Orders are the formal contracts between a Buyer and Seller
                following a transaction on the Seller's Job Page.
                <br />
                Sellers are users who offer and perform services on Decolance.
              </Text>
            </Box>
          </Flex>
        </Stack>
      </CommonContainer>
    </>
  );
}
const list = [
  "Key Terms",
  "User Generated Content",
  "Ownership",
  "Purchase of Voice-Over Commercials",
  "Job Commercial Use Rights",
  "Disclaimer of warranties",
  "Limited Liability",
];
